<!--Options-->
<div class="GridMenu">
	<label>Format:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="FormatOption" [(ngModel)]="FormatOption">
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
			{{ o.Desc }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onDownload()">Download</button>
	<button [disabled]="IsProcessing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
